export const SORT_ASC = 'ASC';
export const SORT_DESC = 'DESC';

export const prepareSearchData = (
  values,
  sortOptions = {},
  isOneFieldSearch = null,
  customCriteria = null,
) => {
  const page = {
    pageNumber: values.offset,
    pageSize: 10,
  };

  let criteria = {};

  if (customCriteria) {
    criteria = customCriteria;
  } else {
    Object.keys(values).forEach((key) => {
      // Special-case: include carType when explicitly set to null (e.g., "All")
      if (key === 'carType' && values[key] === null) {
        criteria[key] = null;
        return;
      }

      if (values[key]) {
        if (
          typeof values[key] === 'object' &&
          Object.prototype.hasOwnProperty.call(values[key], 'value')
        ) {
          // Pass through select value as-is (nulls preserved)
          criteria[key] = values[key].value;
        } else if (isOneFieldSearch && values?.search) {
          criteria.search = values[key];
        } else if (
          Array.isArray(values[key]) &&
          ['fuelType', 'transmission', 'colour'].includes(key)
        ) {
          // Ensure selected multi-value filters are sent as uppercase strings
          criteria[key] = values[key].map((v) =>
            typeof v === 'string' ? v.toUpperCase() : v,
          );
        } else {
          // Primitive values: pass through as-is (nulls preserved)
          criteria[key] = values[key];
        }
      }
    });
  }

  if (criteria.offset) {
    delete criteria.offset;
  }

  if (Object.keys(sortOptions).length) {
    page.sort = {
      orders: [],
    };

    Object.keys(sortOptions).forEach((key) => {
      page.sort.orders.push({
        direction: sortOptions[key],
        property: key,
      });
    });
  }

  return { criteria, page };
};
